import "./CardMapDoctorV2.scss";
import { useRef } from "react";
import * as CheckboxRadix from "@radix-ui/react-checkbox";
import { useClickOutside } from "@/hooks/useClickOutside.ts";
import { ArrowLink, Col, Row } from "@/components";
import { CheckIcon } from "@/icons";
import { HeadingLevel } from "@/types/headings";

type CardMapDoctorProps = {
  doctorCode: string;
  titleTag: HeadingLevel;
  title: string;
  specialization?: string;
  tag?: string;
  officeAddressLabel?: string;
  officeAddress?: string;
  asLink?: "a";
  className?: string;
  isActive: boolean;
  setSelectedDoctorCode: (code?: string) => void;
  keepSelectionOnNavigation?: boolean;
  ctaTitle?: string;
  ctaAction?: () => void;
};

export const CardMapDoctorV2 = ({
  titleTag: TitleTag = "h1",
  title,
  specialization,
  tag,
  officeAddressLabel,
  officeAddress,
  className,
  doctorCode,
  setSelectedDoctorCode,
  keepSelectionOnNavigation = false,
  ctaTitle,
  ctaAction,
  isActive,
}: CardMapDoctorProps) => {
  const dropdownRef = useRef<HTMLDivElement>(null);
  useClickOutside(
    dropdownRef,
    isActive,
    () => setSelectedDoctorCode(undefined),
    () => setSelectedDoctorCode(undefined),
    keepSelectionOnNavigation,
  );

  return (
    <Row
      br={"x4"}
      p={"x24"}
      gap={"x16"}
      bg={"white"}
      text={"slate-20"}
      ref={dropdownRef}
      className={`${className} ${isActive ? "ui-is-active ui-card-search" : "ui-card-search"} shadow cursor-pointer`}
      onClick={() => {
        setSelectedDoctorCode(doctorCode);
      }}
    >
      <CheckboxRadix.Root
        id={doctorCode}
        checked={isActive}
        className={"ui-checkbox-filter"}
        title={`Seleziona ${title}`}
        aria-label={`Seleziona ${title}`}
      >
        <CheckboxRadix.Indicator>
          <CheckIcon width={14} height={14} color="white" />
        </CheckboxRadix.Indicator>
      </CheckboxRadix.Root>
      <Col justifyContent={"center"} className={`w-full`}>
        <Col pb={"x16"}>
          <TitleTag className="flex-1 text-decoration-none fs-4 fw-semibold">
            {title}
          </TitleTag>
          {!!specialization && (
            <p className="fs-6 fw-regular text-slate-28">{specialization}</p>
          )}
          <div
            className={
              "ui-available-label mt-x4 px-x16 py-x4 bg-status-success text-white rounded fw-semibold fs-7"
            }
          >
            {tag}
          </div>
        </Col>
        <Row justifyContent={"space-between"} alignItems={"end"}>
          <div className={"text-slate-28 fs-6"}>
            <div className={"fw-bold"}>{officeAddressLabel}</div>
            <div className={"w-full"}>
              <p className={"fw-regular"}>{officeAddress}</p>
            </div>
          </div>
          {ctaTitle && ctaAction && (
            <ArrowLink
              asButton
              onClick={ctaAction}
              arrowVisible={false}
              className={"cursor-pointer"}
            >
              {ctaTitle}
            </ArrowLink>
          )}
        </Row>
      </Col>
    </Row>
  );
};
